import { Link } from 'react-router-dom';
import { CapaEvento } from '@/components/ui/CapaEvento';

const MESES_CURTO = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

export type TomStatus = 'success' | 'warning' | 'primary' | 'accent' | 'muted';

const TOM: Record<TomStatus, string> = {
  success: 'text-success-600',
  warning: 'text-warning-600',
  primary: 'text-primary-600',
  accent: 'text-accent-600',
  muted: 'text-foreground-500',
};

interface Props {
  nome: string;
  slug: string;
  capa: string | null;
  /** Arte deitada do computador (se faltar, usa a do celular). */
  capaDesktop?: string | null;
  inicioEm: string;
  status: { texto: string; tom: TomStatus };
  atrasoMs?: number;
}

// Cartão pequeno de "Próximos eventos": cartaz inteiro (4:5 no celular,
// 16:9 no computador) sobre a própria arte desfocada, selo de data, nome em
// até 2 linhas e um status curto colorido. Sem arte, entra o degradê da marca.
export default function CardProximoEvento({
  nome,
  slug,
  capa,
  capaDesktop,
  inicioEm,
  status,
  atrasoMs = 0,
}: Props) {
  const d = new Date(inicioEm);
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = MESES_CURTO[d.getMonth()];

  return (
    <Link
      to={`/e/${slug}`}
      className="app-entra aperta block cursor-pointer"
      style={{ animationDelay: `${atrasoMs}ms` }}
    >
      <div className="relative w-full overflow-hidden rounded-[16px] bg-primary-500">
        {capa || capaDesktop ? (
          <CapaEvento
            mobile={capa}
            desktop={capaDesktop ?? capa}
            alt={nome}
            proporcao="4/5"
            proporcaoDesktop="16/9"
            className="!rounded-[16px]"
          />
        ) : (
          <div className="flex aspect-[4/5] h-full w-full items-center justify-center bg-gradient-to-br from-primary-600 to-primary-400 text-white/90">
            <i className="ri-calendar-event-line text-4xl" aria-hidden />
          </div>
        )}

        <span className="absolute left-2 top-2 flex flex-col items-center rounded-[10px] bg-white px-2 py-1 leading-none shadow-sm">
          <span className="text-[10px] font-bold uppercase tracking-wide text-primary-600">
            {mes}
          </span>
          <span className="mt-0.5 text-[15px] font-extrabold text-foreground-950">{dia}</span>
        </span>
      </div>

      <h3 className="mt-2 line-clamp-2 text-[14px] font-bold leading-snug text-foreground-950">
        {nome}
      </h3>
      <p className={`mt-0.5 truncate text-[12px] font-medium ${TOM[status.tom]}`}>
        {status.texto}
      </p>
    </Link>
  );
}